import useSWRMutation from "swr/mutation";
import dayjs from "dayjs";
import { ServicesURL, downloadFile, uploadFile } from "@utils/utilsApi";
import { MethodType } from "src/services/type";
import { getBase64 } from "@pages/Contents/BadgeAndCertificates/utils/utils";

export const useRegistryFile = (
  corporateId: string | number,
  editionId: string | number,
) => {
  const { trigger } = useSWRMutation(
    ServicesURL.postVirtualRegisterFile,
    (url: string, { arg }: { arg: any }) =>
      uploadFile(
        `${url}?editionId=${editionId}`,
        arg,
        MethodType.POST,
        "application/json",
      ),
  );

  const uploadRegistryFile = async (file: File) => {
    const dataUrl = await getBase64(file);
    const base64 = dataUrl.split(",")[1] || "";
    const dotIndex = file.name.lastIndexOf(".");
    const nameNoExt = dotIndex >= 0 ? file.name.slice(0, dotIndex) : file.name;
    const ext = dotIndex >= 0 ? file.name.slice(dotIndex + 1) : "";

    return trigger({
      fileZip: {
        contentFile: base64,
        nomeFile: `${nameNoExt}_${dayjs().format("YYYYMMDDHHmmss")}.${ext}`,
        tipoFile: file.type.split("/")[1] || ext,
      },
      corporateId,
      initiativeId: null,
    });
  };

  const downloadRegistryFile = () =>
    downloadFile(
      `${ServicesURL.getVirtualRegisterFile}?corporateId=${corporateId}&editionId=${editionId}`,
      false,
      "",
    );

  return { uploadRegistryFile, downloadRegistryFile };
};
